// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";

function write__string_list(param) {
  return Atdgen_codec_encode.list(Atdgen_codec_encode.string, param);
}

function read__string_list(param) {
  return Atdgen_codec_decode.list(Atdgen_codec_decode.string, param);
}

const write_wikiPage = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__string_list, "tags", t.tags),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "readingTime", t.readingTime),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "imgUrl", t.imgUrl),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "author", t.author),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "createdAtStr", t.createdAtStr),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "createdAtLongStr", t.createdAtLongStr),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "render", t.render),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
                      tl: /* [] */ 0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_wikiPage = Atdgen_codec_decode.make(function (json) {
  return {
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    tags: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("tags", read__string_list, param);
    }), json),
    readingTime: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("readingTime", Atdgen_codec_decode.$$int, param);
    }), json),
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    imgUrl: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("imgUrl", Atdgen_codec_decode.string, param);
    }), json),
    author: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("author", Atdgen_codec_decode.string, param);
    }), json),
    createdAtStr: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("createdAtStr", Atdgen_codec_decode.string, param);
    }), json),
    createdAtLongStr: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("createdAtLongStr", Atdgen_codec_decode.string, param);
    }), json),
    render: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("render", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json)
  };
});

const write_searchResult = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
        tl: /* [] */ 0
      }
    }
  });
});

const read_searchResult = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__string_nullable(param) {
  return Atdgen_codec_encode.nullable(Atdgen_codec_encode.string, param);
}

function read__string_nullable(param) {
  return Atdgen_codec_decode.nullable(Atdgen_codec_decode.string, param);
}

const write_requisite = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "bin", t.bin),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bank", t.bank),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "iik", t.iik),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "bik", t.bik),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "address", t.address),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "phone", t.phone),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "inn", t.inn),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "okpo", t.okpo),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "account", t.account),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "oked", t.oked),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "mfo", t.mfo),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "kbe", t.kbe),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "country", t.country),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "license", t.license),
                                tl: {
                                  hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "privacy", t.privacy),
                                  tl: {
                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "email", t.email),
                                    tl: {
                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "site", t.site),
                                      tl: /* [] */ 0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_requisite = Atdgen_codec_decode.make(function (json) {
  return {
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    bin: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("bin", read__string_nullable, param);
    }), json),
    bank: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("bank", Atdgen_codec_decode.string, param);
    }), json),
    iik: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("iik", read__string_nullable, param);
    }), json),
    bik: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("bik", read__string_nullable, param);
    }), json),
    address: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("address", Atdgen_codec_decode.string, param);
    }), json),
    phone: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("phone", Atdgen_codec_decode.string, param);
    }), json),
    inn: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("inn", read__string_nullable, param);
    }), json),
    okpo: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("okpo", read__string_nullable, param);
    }), json),
    account: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("account", read__string_nullable, param);
    }), json),
    oked: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("oked", read__string_nullable, param);
    }), json),
    mfo: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("mfo", read__string_nullable, param);
    }), json),
    kbe: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("kbe", read__string_nullable, param);
    }), json),
    country: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("country", Atdgen_codec_decode.string, param);
    }), json),
    license: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("license", read__string_nullable, param);
    }), json),
    privacy: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("privacy", read__string_nullable, param);
    }), json),
    email: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("email", Atdgen_codec_decode.string, param);
    }), json),
    site: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("site", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__requisite_list(param) {
  return Atdgen_codec_encode.list(write_requisite, param);
}

function read__requisite_list(param) {
  return Atdgen_codec_decode.list(read_requisite, param);
}

const write_request = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "company", t.company),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "email", t.email),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "phone", t.phone),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "prefix", t.prefix),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "serviceType", t.serviceType),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bin", t.bin),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "question", t.question),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_request = Atdgen_codec_decode.make(function (json) {
  return {
    company: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("company", Atdgen_codec_decode.string, param);
    }), json),
    email: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("email", Atdgen_codec_decode.string, param);
    }), json),
    phone: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("phone", Atdgen_codec_decode.string, param);
    }), json),
    prefix: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("prefix", Atdgen_codec_decode.string, param);
    }), json),
    serviceType: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("serviceType", Atdgen_codec_decode.string, param);
    }), json),
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    bin: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("bin", Atdgen_codec_decode.string, param);
    }), json),
    question: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("question", Atdgen_codec_decode.string, param);
    }), json)
  };
});

const write_pricingPage = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subtitle", t.subtitle),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "card_title", t.card_title),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "card_text_1", t.card_text_1),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "card_text_2", t.card_text_2),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "from_turnover", t.from_turnover),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "card_title_2", t.card_title_2),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "card_subtitle_2", t.card_subtitle_2),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_pricingPage = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("subtitle", Atdgen_codec_decode.string, param);
    }), json),
    card_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("card_title", Atdgen_codec_decode.string, param);
    }), json),
    card_text_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("card_text_1", Atdgen_codec_decode.string, param);
    }), json),
    card_text_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("card_text_2", Atdgen_codec_decode.string, param);
    }), json),
    from_turnover: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("from_turnover", Atdgen_codec_decode.string, param);
    }), json),
    card_title_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("card_title_2", Atdgen_codec_decode.string, param);
    }), json),
    card_subtitle_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("card_subtitle_2", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__int_nullable(param) {
  return Atdgen_codec_encode.nullable(Atdgen_codec_encode.$$int, param);
}

function read__int_nullable(param) {
  return Atdgen_codec_decode.nullable(Atdgen_codec_decode.$$int, param);
}

const write_price = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, write__int_nullable, "price", t.price),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "period", t.period),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "currency", t.currency),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "prefix", t.prefix),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  });
});

const read_price = Atdgen_codec_decode.make(function (json) {
  return {
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", read__string_nullable, param);
    }), json),
    price: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("price", read__int_nullable, param);
    }), json),
    period: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("period", read__string_nullable, param);
    }), json),
    currency: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("currency", read__string_nullable, param);
    }), json),
    prefix: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("prefix", read__string_nullable, param);
    }), json)
  };
});

function write__price_list(param) {
  return Atdgen_codec_encode.list(write_price, param);
}

function read__price_list(param) {
  return Atdgen_codec_decode.list(read_price, param);
}

const write_pricingCategory = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "icon", t.icon),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, write__price_list, "prices", t.prices),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "country", t.country),
            tl: /* [] */ 0
          }
        }
      }
    }
  });
});

const read_pricingCategory = Atdgen_codec_decode.make(function (json) {
  return {
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    icon: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("icon", Atdgen_codec_decode.string, param);
    }), json),
    prices: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("prices", read__price_list, param);
    }), json),
    country: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("country", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__pricingCategory_list(param) {
  return Atdgen_codec_encode.list(write_pricingCategory, param);
}

function read__pricingCategory_list(param) {
  return Atdgen_codec_decode.list(read_pricingCategory, param);
}

const write_outsourcing = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subtitle", t.subtitle),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "note", t.note),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "country", t.country),
        tl: /* [] */ 0
      }
    }
  });
});

const read_outsourcing = Atdgen_codec_decode.make(function (json) {
  return {
    subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("subtitle", Atdgen_codec_decode.string, param);
    }), json),
    note: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("note", Atdgen_codec_decode.string, param);
    }), json),
    country: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("country", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__outsourcing_list(param) {
  return Atdgen_codec_encode.list(write_outsourcing, param);
}

function read__outsourcing_list(param) {
  return Atdgen_codec_decode.list(read_outsourcing, param);
}

const write_menuItem = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subtitle", t.subtitle),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "path", t.path),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "icon", t.icon),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "order", t.order),
            tl: /* [] */ 0
          }
        }
      }
    }
  });
});

const read_menuItem = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("subtitle", Atdgen_codec_decode.string, param);
    }), json),
    path: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("path", Atdgen_codec_decode.string, param);
    }), json),
    icon: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("icon", Atdgen_codec_decode.string, param);
    }), json),
    order: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("order", Atdgen_codec_decode.$$int, param);
    }), json)
  };
});

function write__menuItem_list(param) {
  return Atdgen_codec_encode.list(write_menuItem, param);
}

function read__menuItem_list(param) {
  return Atdgen_codec_decode.list(read_menuItem, param);
}

const write_mainMenu = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "type_", t.type_),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, write__menuItem_list, "menu_items", t.menu_items),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "link", t.link),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "country", t.country),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "order", t.order),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  });
});

const read_mainMenu = Atdgen_codec_decode.make(function (json) {
  return {
    type_: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("type_", Atdgen_codec_decode.string, param);
    }), json),
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    menu_items: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("menu_items", read__menuItem_list, param);
    }), json),
    link: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("link", read__string_nullable, param);
    }), json),
    country: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("country", Atdgen_codec_decode.string, param);
    }), json),
    order: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("order", Atdgen_codec_decode.$$int, param);
    }), json)
  };
});

function write__mainMenu_list(param) {
  return Atdgen_codec_encode.list(write_mainMenu, param);
}

function read__mainMenu_list(param) {
  return Atdgen_codec_decode.list(read_mainMenu, param);
}

const write_libraryTag = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "tag", t.tag),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: /* [] */ 0
      }
    }
  });
});

const read_libraryTag = Atdgen_codec_decode.make(function (json) {
  return {
    tag: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("tag", Atdgen_codec_decode.string, param);
    }), json),
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__libraryTag_list(param) {
  return Atdgen_codec_encode.list(write_libraryTag, param);
}

function read__libraryTag_list(param) {
  return Atdgen_codec_decode.list(read_libraryTag, param);
}

const write_librarySearchResult = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
        tl: /* [] */ 0
      }
    }
  });
});

const read_librarySearchResult = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__librarySearchResult_list(param) {
  return Atdgen_codec_encode.list(write_librarySearchResult, param);
}

function read__librarySearchResult_list(param) {
  return Atdgen_codec_decode.list(read_librarySearchResult, param);
}

const write_libraryFavorite = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
          tl: /* [] */ 0
        }
      }
    }
  });
});

const read_libraryFavorite = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__libraryFavorite_list(param) {
  return Atdgen_codec_encode.list(write_libraryFavorite, param);
}

function read__libraryFavorite_list(param) {
  return Atdgen_codec_decode.list(read_libraryFavorite, param);
}

const write_libraryArticle = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
          tl: /* [] */ 0
        }
      }
    }
  });
});

const read_libraryArticle = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__libraryArticle_list(param) {
  return Atdgen_codec_encode.list(write_libraryArticle, param);
}

function read__libraryArticle_list(param) {
  return Atdgen_codec_decode.list(read_libraryArticle, param);
}

const write_libraryArticles = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "total", t.total),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__libraryArticle_list, "results", t.results),
      tl: /* [] */ 0
    }
  });
});

const read_libraryArticles = Atdgen_codec_decode.make(function (json) {
  return {
    total: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("total", Atdgen_codec_decode.$$int, param);
    }), json),
    results: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("results", read__libraryArticle_list, param);
    }), json)
  };
});

const write_job = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "city", t.city),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "experience", t.experience),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "requirements", t.requirements),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "responsibilities", t.responsibilities),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "speciality", t.speciality),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "conditions", t.conditions),
                      tl: /* [] */ 0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_job = Atdgen_codec_decode.make(function (json) {
  return {
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json),
    city: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("city", Atdgen_codec_decode.string, param);
    }), json),
    experience: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("experience", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    requirements: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("requirements", Atdgen_codec_decode.string, param);
    }), json),
    responsibilities: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("responsibilities", Atdgen_codec_decode.string, param);
    }), json),
    speciality: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("speciality", Atdgen_codec_decode.string, param);
    }), json),
    conditions: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("conditions", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__job_list(param) {
  return Atdgen_codec_encode.list(write_job, param);
}

function read__job_list(param) {
  return Atdgen_codec_decode.list(read_job, param);
}

const write_jobCategory = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__job_list, "jobs", t.jobs),
      tl: /* [] */ 0
    }
  });
});

const read_jobCategory = Atdgen_codec_decode.make(function (json) {
  return {
    name: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
    }), json),
    jobs: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("jobs", read__job_list, param);
    }), json)
  };
});

function write__jobCategory_list(param) {
  return Atdgen_codec_encode.list(write_jobCategory, param);
}

function read__jobCategory_list(param) {
  return Atdgen_codec_decode.list(read_jobCategory, param);
}

const write_homePage = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subtitle", t.subtitle),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "feature_heading_1", t.feature_heading_1),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "feature_text_1", t.feature_text_1),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "feature_heading_2", t.feature_heading_2),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "feature_text_2", t.feature_text_2),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_title", t.carousel_title),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_feature_1", t.carousel_feature_1),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_feature_2", t.carousel_feature_2),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_feature_3", t.carousel_feature_3),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_title_1", t.carousel_item_title_1),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_text_1", t.carousel_item_text_1),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_subtext_1", t.carousel_item_subtext_1),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_title_2", t.carousel_item_title_2),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_text_2", t.carousel_item_text_2),
                                tl: {
                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_subtext_2", t.carousel_item_subtext_2),
                                  tl: {
                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_title_3", t.carousel_item_title_3),
                                    tl: {
                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_text_3", t.carousel_item_text_3),
                                      tl: {
                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_item_subtext_3", t.carousel_item_subtext_3),
                                        tl: {
                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_title", t.client_title),
                                          tl: {
                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_subtitle", t.client_subtitle),
                                            tl: {
                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_quote_1", t.client_quote_1),
                                              tl: {
                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_name_1", t.client_name_1),
                                                tl: {
                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_quote_2", t.client_quote_2),
                                                  tl: {
                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "client_name_2", t.client_name_2),
                                                    tl: {
                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "business_count", t.business_count),
                                                      tl: {
                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "outsourcing_title", t.outsourcing_title),
                                                        tl: {
                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "outsourcing_text", t.outsourcing_text),
                                                          tl: {
                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_quote_1", t.carousel_client_quote_1),
                                                            tl: {
                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_name_1", t.carousel_client_name_1),
                                                              tl: {
                                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_quote_2", t.carousel_client_quote_2),
                                                                tl: {
                                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_name_2", t.carousel_client_name_2),
                                                                  tl: {
                                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_quote_3", t.carousel_client_quote_3),
                                                                    tl: {
                                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "carousel_client_name_3", t.carousel_client_name_3),
                                                                      tl: {
                                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "last_feature_title_1", t.last_feature_title_1),
                                                                        tl: {
                                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "last_feature_text_1", t.last_feature_text_1),
                                                                          tl: {
                                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "last_feature_title_2", t.last_feature_title_2),
                                                                            tl: {
                                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "last_feature_text_2", t.last_feature_text_2),
                                                                              tl: /* [] */ 0
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_homePage = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("subtitle", Atdgen_codec_decode.string, param);
    }), json),
    feature_heading_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("feature_heading_1", Atdgen_codec_decode.string, param);
    }), json),
    feature_text_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("feature_text_1", Atdgen_codec_decode.string, param);
    }), json),
    feature_heading_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("feature_heading_2", Atdgen_codec_decode.string, param);
    }), json),
    feature_text_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("feature_text_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_title", Atdgen_codec_decode.string, param);
    }), json),
    carousel_feature_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_feature_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_feature_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_feature_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_feature_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_feature_3", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_title_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_title_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_text_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_text_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_subtext_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_subtext_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_title_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_title_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_text_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_text_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_subtext_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_subtext_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_title_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_title_3", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_text_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_text_3", Atdgen_codec_decode.string, param);
    }), json),
    carousel_item_subtext_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_item_subtext_3", Atdgen_codec_decode.string, param);
    }), json),
    client_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_title", Atdgen_codec_decode.string, param);
    }), json),
    client_subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_subtitle", Atdgen_codec_decode.string, param);
    }), json),
    client_quote_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_quote_1", Atdgen_codec_decode.string, param);
    }), json),
    client_name_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_name_1", Atdgen_codec_decode.string, param);
    }), json),
    client_quote_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_quote_2", Atdgen_codec_decode.string, param);
    }), json),
    client_name_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("client_name_2", Atdgen_codec_decode.string, param);
    }), json),
    business_count: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("business_count", Atdgen_codec_decode.string, param);
    }), json),
    outsourcing_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("outsourcing_title", Atdgen_codec_decode.string, param);
    }), json),
    outsourcing_text: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("outsourcing_text", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_quote_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_quote_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_name_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_name_1", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_quote_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_quote_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_name_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_name_2", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_quote_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_quote_3", Atdgen_codec_decode.string, param);
    }), json),
    carousel_client_name_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("carousel_client_name_3", Atdgen_codec_decode.string, param);
    }), json),
    last_feature_title_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("last_feature_title_1", Atdgen_codec_decode.string, param);
    }), json),
    last_feature_text_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("last_feature_text_1", Atdgen_codec_decode.string, param);
    }), json),
    last_feature_title_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("last_feature_title_2", Atdgen_codec_decode.string, param);
    }), json),
    last_feature_text_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("last_feature_text_2", Atdgen_codec_decode.string, param);
    }), json)
  };
});

const write_faq = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "question", t.question),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "answer", t.answer),
      tl: /* [] */ 0
    }
  });
});

const read_faq = Atdgen_codec_decode.make(function (json) {
  return {
    question: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("question", Atdgen_codec_decode.string, param);
    }), json),
    answer: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("answer", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__faq_list(param) {
  return Atdgen_codec_encode.list(write_faq, param);
}

function read__faq_list(param) {
  return Atdgen_codec_decode.list(read_faq, param);
}

const write_blogTag = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "tag", t.tag),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: /* [] */ 0
      }
    }
  });
});

const read_blogTag = Atdgen_codec_decode.make(function (json) {
  return {
    tag: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("tag", Atdgen_codec_decode.string, param);
    }), json),
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__blogTag_list(param) {
  return Atdgen_codec_encode.list(write_blogTag, param);
}

function read__blogTag_list(param) {
  return Atdgen_codec_decode.list(read_blogTag, param);
}

function write__searchResult_list(param) {
  return Atdgen_codec_encode.list(write_searchResult, param);
}

function read__searchResult_list(param) {
  return Atdgen_codec_decode.list(read_searchResult, param);
}

const write_blogPost = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, write__string_list, "tags", t.tags),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "author", t.author),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "imgUrl", t.imgUrl),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "createdAtStr", t.createdAtStr),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "createdAtLongStr", t.createdAtLongStr),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "readingTime", t.readingTime),
                      tl: /* [] */ 0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_blogPost = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json),
    tags: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("tags", read__string_list, param);
    }), json),
    author: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("author", Atdgen_codec_decode.string, param);
    }), json),
    imgUrl: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("imgUrl", Atdgen_codec_decode.string, param);
    }), json),
    createdAtStr: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("createdAtStr", Atdgen_codec_decode.string, param);
    }), json),
    createdAtLongStr: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("createdAtLongStr", Atdgen_codec_decode.string, param);
    }), json),
    readingTime: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("readingTime", Atdgen_codec_decode.$$int, param);
    }), json)
  };
});

function write__blogPost_list(param) {
  return Atdgen_codec_encode.list(write_blogPost, param);
}

function read__blogPost_list(param) {
  return Atdgen_codec_decode.list(read_blogPost, param);
}

const write_blogPosts = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "total", t.total),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__blogPost_list, "results", t.results),
      tl: /* [] */ 0
    }
  });
});

const read_blogPosts = Atdgen_codec_decode.make(function (json) {
  return {
    total: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("total", Atdgen_codec_decode.$$int, param);
    }), json),
    results: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("results", read__blogPost_list, param);
    }), json)
  };
});

const write_blogFavorite = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "description", t.description),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "slug", t.slug),
          tl: /* [] */ 0
        }
      }
    }
  });
});

const read_blogFavorite = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    description: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("description", Atdgen_codec_decode.string, param);
    }), json),
    id: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
    }), json),
    slug: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("slug", Atdgen_codec_decode.string, param);
    }), json)
  };
});

function write__blogFavorite_list(param) {
  return Atdgen_codec_encode.list(write_blogFavorite, param);
}

function read__blogFavorite_list(param) {
  return Atdgen_codec_decode.list(read_blogFavorite, param);
}

const write_aboutPage = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title", t.title),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "paragraph", t.paragraph),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subtext", t.subtext),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "title_2", t.title_2),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "paragraph_2", t.paragraph_2),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_title", t.list_title),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_1", t.list_item_1),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2", t.list_item_2),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_3", t.list_item_3),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_4", t.list_item_4),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_5", t.list_item_5),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_6", t.list_item_6),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_7", t.list_item_7),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_subtext_7", t.list_item_subtext_7),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_title_2", t.list_title_2),
                                tl: {
                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_1", t.list_item_2_1),
                                  tl: {
                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_2", t.list_item_2_2),
                                    tl: {
                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_3", t.list_item_2_3),
                                      tl: {
                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_4", t.list_item_2_4),
                                        tl: {
                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_5", t.list_item_2_5),
                                          tl: {
                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_6", t.list_item_2_6),
                                            tl: {
                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_7", t.list_item_2_7),
                                              tl: {
                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_8", t.list_item_2_8),
                                                tl: {
                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "list_item_2_9", t.list_item_2_9),
                                                  tl: {
                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "how_title", t.how_title),
                                                    tl: {
                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "how_item_1", t.how_item_1),
                                                      tl: {
                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "how_item_2", t.how_item_2),
                                                        tl: {
                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "how_item_3", t.how_item_3),
                                                          tl: {
                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "who_title", t.who_title),
                                                            tl: {
                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "who_subtitle", t.who_subtitle),
                                                              tl: {
                                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_title", t.media_title),
                                                                tl: {
                                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_text_1", t.media_text_1),
                                                                  tl: {
                                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_link_1", t.media_link_1),
                                                                    tl: {
                                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_name_1", t.media_name_1),
                                                                      tl: {
                                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_text_2", t.media_text_2),
                                                                        tl: {
                                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_link_2", t.media_link_2),
                                                                          tl: {
                                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_name_2", t.media_name_2),
                                                                            tl: {
                                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_text_3", t.media_text_3),
                                                                              tl: {
                                                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_link_3", t.media_link_3),
                                                                                tl: {
                                                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_name_3", t.media_name_3),
                                                                                  tl: {
                                                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_text_4", t.media_text_4),
                                                                                    tl: {
                                                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_link_4", t.media_link_4),
                                                                                      tl: {
                                                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "media_name_4", t.media_name_4),
                                                                                        tl: {
                                                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "coverage_title", t.coverage_title),
                                                                                          tl: {
                                                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "coverage_workers", t.coverage_workers),
                                                                                            tl: {
                                                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "coverage_clients", t.coverage_clients),
                                                                                              tl: {
                                                                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "coverage_solutions", t.coverage_solutions),
                                                                                                tl: {
                                                                                                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "pricing_title", t.pricing_title),
                                                                                                  tl: {
                                                                                                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "pricing_subtitle", t.pricing_subtitle),
                                                                                                    tl: {
                                                                                                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "question_1", t.question_1),
                                                                                                      tl: {
                                                                                                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "answer_1", t.answer_1),
                                                                                                        tl: {
                                                                                                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "question_2", t.question_2),
                                                                                                          tl: {
                                                                                                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "answer_2", t.answer_2),
                                                                                                            tl: {
                                                                                                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "question_3", t.question_3),
                                                                                                              tl: {
                                                                                                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "answer_3", t.answer_3),
                                                                                                                tl: /* [] */ 0
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_aboutPage = Atdgen_codec_decode.make(function (json) {
  return {
    title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title", Atdgen_codec_decode.string, param);
    }), json),
    paragraph: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("paragraph", Atdgen_codec_decode.string, param);
    }), json),
    subtext: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("subtext", Atdgen_codec_decode.string, param);
    }), json),
    title_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("title_2", Atdgen_codec_decode.string, param);
    }), json),
    paragraph_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("paragraph_2", Atdgen_codec_decode.string, param);
    }), json),
    list_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_title", Atdgen_codec_decode.string, param);
    }), json),
    list_item_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_1", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2", Atdgen_codec_decode.string, param);
    }), json),
    list_item_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_3", Atdgen_codec_decode.string, param);
    }), json),
    list_item_4: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_4", Atdgen_codec_decode.string, param);
    }), json),
    list_item_5: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_5", Atdgen_codec_decode.string, param);
    }), json),
    list_item_6: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_6", Atdgen_codec_decode.string, param);
    }), json),
    list_item_7: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_7", Atdgen_codec_decode.string, param);
    }), json),
    list_item_subtext_7: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_subtext_7", Atdgen_codec_decode.string, param);
    }), json),
    list_title_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_title_2", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_1", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_2", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_3", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_4: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_4", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_5: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_5", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_6: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_6", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_7: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_7", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_8: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_8", Atdgen_codec_decode.string, param);
    }), json),
    list_item_2_9: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("list_item_2_9", Atdgen_codec_decode.string, param);
    }), json),
    how_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("how_title", Atdgen_codec_decode.string, param);
    }), json),
    how_item_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("how_item_1", Atdgen_codec_decode.string, param);
    }), json),
    how_item_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("how_item_2", Atdgen_codec_decode.string, param);
    }), json),
    how_item_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("how_item_3", Atdgen_codec_decode.string, param);
    }), json),
    who_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("who_title", Atdgen_codec_decode.string, param);
    }), json),
    who_subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("who_subtitle", Atdgen_codec_decode.string, param);
    }), json),
    media_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_title", Atdgen_codec_decode.string, param);
    }), json),
    media_text_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_text_1", Atdgen_codec_decode.string, param);
    }), json),
    media_link_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_link_1", Atdgen_codec_decode.string, param);
    }), json),
    media_name_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_name_1", Atdgen_codec_decode.string, param);
    }), json),
    media_text_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_text_2", Atdgen_codec_decode.string, param);
    }), json),
    media_link_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_link_2", Atdgen_codec_decode.string, param);
    }), json),
    media_name_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_name_2", Atdgen_codec_decode.string, param);
    }), json),
    media_text_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_text_3", Atdgen_codec_decode.string, param);
    }), json),
    media_link_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_link_3", Atdgen_codec_decode.string, param);
    }), json),
    media_name_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_name_3", Atdgen_codec_decode.string, param);
    }), json),
    media_text_4: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_text_4", Atdgen_codec_decode.string, param);
    }), json),
    media_link_4: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_link_4", Atdgen_codec_decode.string, param);
    }), json),
    media_name_4: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("media_name_4", Atdgen_codec_decode.string, param);
    }), json),
    coverage_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("coverage_title", Atdgen_codec_decode.string, param);
    }), json),
    coverage_workers: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("coverage_workers", Atdgen_codec_decode.string, param);
    }), json),
    coverage_clients: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("coverage_clients", Atdgen_codec_decode.string, param);
    }), json),
    coverage_solutions: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("coverage_solutions", Atdgen_codec_decode.string, param);
    }), json),
    pricing_title: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("pricing_title", Atdgen_codec_decode.string, param);
    }), json),
    pricing_subtitle: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("pricing_subtitle", Atdgen_codec_decode.string, param);
    }), json),
    question_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("question_1", Atdgen_codec_decode.string, param);
    }), json),
    answer_1: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("answer_1", Atdgen_codec_decode.string, param);
    }), json),
    question_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("question_2", Atdgen_codec_decode.string, param);
    }), json),
    answer_2: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("answer_2", Atdgen_codec_decode.string, param);
    }), json),
    question_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("question_3", Atdgen_codec_decode.string, param);
    }), json),
    answer_3: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("answer_3", Atdgen_codec_decode.string, param);
    }), json)
  };
});

const write_content = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, write__pricingCategory_list, "pricingCategories", t.pricingCategories),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write__outsourcing_list, "outsourcings", t.outsourcings),
      tl: {
        hd: Atdgen_codec_encode.field(undefined, write__blogTag_list, "blogTags", t.blogTags),
        tl: {
          hd: Atdgen_codec_encode.field(undefined, write_blogPosts, "blogPosts", t.blogPosts),
          tl: {
            hd: Atdgen_codec_encode.field(undefined, write__blogFavorite_list, "blogFavorites", t.blogFavorites),
            tl: {
              hd: Atdgen_codec_encode.field(undefined, write__searchResult_list, "blogSearch", t.blogSearch),
              tl: {
                hd: Atdgen_codec_encode.field(undefined, write_wikiPage, "wikiPage", t.wikiPage),
                tl: {
                  hd: Atdgen_codec_encode.field(undefined, write__libraryTag_list, "libraryTags", t.libraryTags),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write__libraryFavorite_list, "libraryFavorites", t.libraryFavorites),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write_libraryArticles, "libraryArticles", t.libraryArticles),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, write__librarySearchResult_list, "librarySearch", t.librarySearch),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, write_aboutPage, "aboutPage", t.aboutPage),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, write__requisite_list, "requisites", t.requisites),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, write__faq_list, "faqs", t.faqs),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, write_homePage, "homePage", t.homePage),
                                tl: {
                                  hd: Atdgen_codec_encode.field(undefined, write__jobCategory_list, "jobCategories", t.jobCategories),
                                  tl: {
                                    hd: Atdgen_codec_encode.field(undefined, write__mainMenu_list, "mainMenus", t.mainMenus),
                                    tl: {
                                      hd: Atdgen_codec_encode.field(undefined, write_pricingPage, "pricingPage", t.pricingPage),
                                      tl: /* [] */ 0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
});

const read_content = Atdgen_codec_decode.make(function (json) {
  return {
    pricingCategories: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("pricingCategories", read__pricingCategory_list, param);
    }), json),
    outsourcings: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("outsourcings", read__outsourcing_list, param);
    }), json),
    blogTags: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("blogTags", read__blogTag_list, param);
    }), json),
    blogPosts: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("blogPosts", read_blogPosts, param);
    }), json),
    blogFavorites: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("blogFavorites", read__blogFavorite_list, param);
    }), json),
    blogSearch: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("blogSearch", read__searchResult_list, param);
    }), json),
    wikiPage: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("wikiPage", read_wikiPage, param);
    }), json),
    libraryTags: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("libraryTags", read__libraryTag_list, param);
    }), json),
    libraryFavorites: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("libraryFavorites", read__libraryFavorite_list, param);
    }), json),
    libraryArticles: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("libraryArticles", read_libraryArticles, param);
    }), json),
    librarySearch: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("librarySearch", read__librarySearchResult_list, param);
    }), json),
    aboutPage: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("aboutPage", read_aboutPage, param);
    }), json),
    requisites: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("requisites", read__requisite_list, param);
    }), json),
    faqs: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("faqs", read__faq_list, param);
    }), json),
    homePage: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("homePage", read_homePage, param);
    }), json),
    jobCategories: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("jobCategories", read__jobCategory_list, param);
    }), json),
    mainMenus: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("mainMenus", read__mainMenu_list, param);
    }), json),
    pricingPage: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("pricingPage", read_pricingPage, param);
    }), json)
  };
});

const read_requisites = read__requisite_list;

const write_requisites = write__requisite_list;

const read_pricingCategories = read__pricingCategory_list;

const write_pricingCategories = write__pricingCategory_list;

const read_outsourcings = read__outsourcing_list;

const write_outsourcings = write__outsourcing_list;

const read_mainMenus = read__mainMenu_list;

const write_mainMenus = write__mainMenu_list;

const read_libraryTags = read__libraryTag_list;

const write_libraryTags = write__libraryTag_list;

const read_librarySearch = read__librarySearchResult_list;

const write_librarySearch = write__librarySearchResult_list;

const read_libraryFavorites = read__libraryFavorite_list;

const write_libraryFavorites = write__libraryFavorite_list;

const read_jobCategories = read__jobCategory_list;

const write_jobCategories = write__jobCategory_list;

const read_faqs = read__faq_list;

const write_faqs = write__faq_list;

const read_blogTags = read__blogTag_list;

const write_blogTags = write__blogTag_list;

const read_blogSearch = read__searchResult_list;

const write_blogSearch = write__searchResult_list;

const read_blogFavorites = read__blogFavorite_list;

const write_blogFavorites = write__blogFavorite_list;

export {
  read_wikiPage,
  write_wikiPage,
  read_searchResult,
  write_searchResult,
  read_requisite,
  write_requisite,
  read_requisites,
  write_requisites,
  read_request,
  write_request,
  read_pricingPage,
  write_pricingPage,
  read_price,
  write_price,
  read_pricingCategory,
  write_pricingCategory,
  read_pricingCategories,
  write_pricingCategories,
  read_outsourcing,
  write_outsourcing,
  read_outsourcings,
  write_outsourcings,
  read_menuItem,
  write_menuItem,
  read_mainMenu,
  write_mainMenu,
  read_mainMenus,
  write_mainMenus,
  read_libraryTag,
  write_libraryTag,
  read_libraryTags,
  write_libraryTags,
  read_librarySearchResult,
  write_librarySearchResult,
  read_librarySearch,
  write_librarySearch,
  read_libraryFavorite,
  write_libraryFavorite,
  read_libraryFavorites,
  write_libraryFavorites,
  read_libraryArticle,
  write_libraryArticle,
  read_libraryArticles,
  write_libraryArticles,
  read_job,
  write_job,
  read_jobCategory,
  write_jobCategory,
  read_jobCategories,
  write_jobCategories,
  read_homePage,
  write_homePage,
  read_faq,
  write_faq,
  read_faqs,
  write_faqs,
  read_blogTag,
  write_blogTag,
  read_blogTags,
  write_blogTags,
  read_blogSearch,
  write_blogSearch,
  read_blogPost,
  write_blogPost,
  read_blogPosts,
  write_blogPosts,
  read_blogFavorite,
  write_blogFavorite,
  read_blogFavorites,
  write_blogFavorites,
  read_aboutPage,
  write_aboutPage,
  read_content,
  write_content,
}
/* write_wikiPage Not a pure module */
